import React from 'react';
import { Icon, Tooltip } from "antd";
import moment from 'moment';
import 'moment-timezone';
import formatter from '../../../../../../utils/formatter';
import { ColumnTitleMobile, ColumnValue, UnderlyingContent } from "../../styles";
import { ExchangeFromTable } from "./styles";
import { replaceSelect } from "../../../../../../utils/replacer";

const ToTable = (props) => {
    const { dataSource, instructionType, status, isReview, isLegacy = false,  reversedExchange = false } = props;
    let columns = [
        {
            title: 'Investment Options',
            className: "investment-pool-title hide-col-title-in-mobile",
            render: (record) => replaceSelect(record.investmentOption),
            key: "investmentOption",
            width: "25%"
        },
        {
            title: () => <>{ reversedExchange && (status === 'Entered' || status === 'Cancelled') && instructionType ==='UNITS' ? 'Units' : reversedExchange && status === 'Completed' && (instructionType ==='DOLLAR' || instructionType === 'PERCENTAGE') ? 'Dollar' : 'Percentage' }</>,
            className: "hide-col-title-in-mobile cell-w100",
            render: (record) => {
                let colValue =  reversedExchange && (status === 'Entered' || status === 'Cancelled') && instructionType ==='UNITS' ? formatter({
                    value: record.unit,
                    fieldSuffix: "Units"
                }) :  reversedExchange && status === 'Completed' && (instructionType ==='DOLLAR' || instructionType === 'PERCENTAGE') ? formatter({
                    value: record.value,
                    fieldSuffix: "Dollars"
                }) : formatter({
                    value: record.percentage,
                    fieldSuffix: "Percentage"
                })
                return <>
                    <ColumnTitleMobile>{ reversedExchange && (status === 'Entered' || status === 'Cancelled') && instructionType ==='UNITS' ? 'Units' : reversedExchange && status === 'Completed' && (instructionType ==='DOLLAR' || instructionType === 'PERCENTAGE') ? 'Dollar' : 'Percentage' }</ColumnTitleMobile>
                    <ColumnValue>{colValue}</ColumnValue>
                </>
            },
            key: "percentage",
            width: "25%"
        }
    ];
    if(isReview) {
        columns.splice(1, 0, {
            title: "Available Balance",
            className: "hide-col-title-in-mobile",
            render: (record) => {
                let colValue = record.availableBalance ?  formatter({
                    value: record.availableBalance,
                    fieldSuffix: "Dollars"
                }) : '—'
                return <>
                    <ColumnTitleMobile>Available Balance</ColumnTitleMobile>
                    <ColumnValue>{colValue}</ColumnValue>
                </>
            },
            key: "currentBalance",
            width: "25%"
        },
        {
            title: () => <>
                <div>Price per unit</div>
            </>,
            className: "hide-col-title-in-mobile",
            render: (record) => {
                const perUpdatedOn = 'Price updated on ' + moment(moment.tz(record.asOfDate, 'America/New_York')).format('MM/DD/YYYY')
                return <>
                    <ColumnTitleMobile>Price per unit</ColumnTitleMobile>
                    <ColumnValue>
                        <>
                            <Tooltip placement="bottomLeft" title={perUpdatedOn}>
                                    <UnderlyingContent>
                                        {(record.currentNAV || record.currentNav) &&
                                            <div>{formatter({value: record.currentNAV || record.currentNav, fieldSuffix: 'Dollars'})} <Icon type={record.isRise ? 'caret-up' : 'caret-down'} /> </div>
                                        }
                                    </UnderlyingContent>
                            </Tooltip>
                            {!(record.currentNAV || record.currentNav) &&
                                <div>-</div>
                            }
                        </>
                    </ColumnValue>
                </>
            },
            key: "currentNAV",
            width: "25%"
        });
    }
    let columnsLegacy = isLegacy && [
        {
            title: 'Investment Options',
            className: "investment-pool-title hide-col-title-in-mobile",
            render: (record) => replaceSelect(record.investmentOption),
            key: "investmentOption",
            width: "25%"
        },
        {
            className: "hide-col-title-in-mobile cell-w100",
            render: (record) => {
                let colValue = formatter({
                    value: record.value,
                    fieldSuffix: "Dollars"
                })
                return <>
                    <ColumnValue>{colValue}</ColumnValue>
                </>
            },
            key: "value",
            width: "25%"
        }
    ];

    if(props.isPrintCheck){
        return props.printRender(isLegacy ? columnsLegacy : columns);
    }
    return (
        <ExchangeFromTable
            data-test="container"
            pagination={false}            
            columns={isLegacy ? columnsLegacy : columns}
            dataSource={dataSource}
            rowKey={(record) => record.id && record.id.toString()}
        />
    );
};

export default ToTable;